<template>
    <date-picker :placeholder="placeholder"
                 :lang="lang"
                 input-class="a-input a-input--w-280"
                 v-model="date"
                 format="DD.MM.YYYY"
                 editable
                 clearable
                 append-to-body
                 @closed="$emit('closed')">
      <template v-slot:icon-calendar><i></i></template>
    </date-picker>
</template>

<script>
  import DatePicker from 'vue2-datepicker'
  import 'vue2-datepicker/locale/ru';

  export default {
    components: {
      DatePicker
    },

    props: {
      value: Date,

      placeholder: {
        type: String,
        default: 'дд.мм.гггг'
      },

      time: {
        type: String,
        default: 'current'
      }
    },

    computed: {
      lang() {
        return DatePicker.locale('ru');
      },

      date: {
        get() {
          //return this.value;
          return this.value ? new Date(this.$moment(this.value).tz('Europe/Minsk').format('YYYY-MM-DDTHH:mm:ss')) : this.value;
        },

        set(value) {
          if (typeof value === 'number') value = new Date(value);

          if (value instanceof Date) {
            const date = this.$moment(value).format('YYYYMMDD');

            if (this.time === 'startOfDay') {
              value = this.$moment.tz(`${date}:000000`, 'YYYYMMDD:HHmmss', 'Europe/Minsk').toDate();
            }
            else if (this.time === 'endOfDay') {
              value = this.$moment.tz(`${date}:235959`, 'YYYYMMDD:HHmmss', 'Europe/Minsk').toDate();
            }
          }
          else {
            value = undefined;
          }

          console.log(+value);

          this.$emit('input', value);
          this.$emit('change', value);
        }
      }
    }
  }
</script>

<style lang="scss">
  $default-color: #555;
  $primary-color: #808080;
  $today-color: white;

  @import '~vue2-datepicker/scss/index.scss';

  .mx-datepicker {
    width: initial;
  }

  .today {
    background: $primary-color;
  }
</style>
